/**
 * Import & export all components fields here, and only here !
 * Please respect the alphabetic order
 */
import { ChipsModule } from './chips/chips.module';
import { AutoCompleteFieldModule } from './autocomplete-legacy/autocomplete-field.module';
import { DateFieldModule } from './date-field/date-field.module';
import { DropdownFieldModule } from './dropdown-field/dropdown-field.module';
import { MultiSelectFieldModule } from './multiselect-field/multiselect-field.module';
import { NumberFieldModule } from './number-field/number-field.module';
import { TextareaFieldModule } from './textarea-field/textarea-field.module';
import { TextFieldModule } from './text-field/text-field.module';
import { FormFieldModule } from './form-field/form-field.module';
import { CalendarModule } from './calendar/calendar.module';


/** Export components to module */
export const fieldComponents = [
];

export const fieldsModules = [
    CalendarModule,
    ChipsModule,
    FormFieldModule,
    AutoCompleteFieldModule,
    DateFieldModule,
    DropdownFieldModule,
    MultiSelectFieldModule,
    NumberFieldModule,
    TextareaFieldModule,
    TextFieldModule,
];
